import { Anchor, Card, Stack, Text } from '@mantine/core';
import { GroupRequirementsCard } from './GroupRequirementsCard';
import { MatchingGoalsCard } from './MatchingGoalsCard';

interface RulesAndGoalsStepProps {
  goalColumn: string | null;
  onGoalColumnChange: (column: string | null) => void;
}

export function RulesAndGoalsStep({
  goalColumn,
  onGoalColumnChange,
}: RulesAndGoalsStepProps) {
  return (
    <Stack gap="lg">
      <Card withBorder radius="lg" px={28} py={20}>
        <Text lh={1.6}>
          Tell the matching tool what it has to work with.{' '}
          <b>Group requirements</b> come first: essential for every group, and
          matching stops if one can't be met. Further down are your{' '}
          <b>matching goals</b>: what you'd like matching to work toward, which
          may not all be met.{' '}
          <Anchor
            fw={600}
            href="#matching-goals"
            onClick={e => {
              e.preventDefault();
              document
                .getElementById('matching-goals')
                ?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Jump to matching goals
          </Anchor>
        </Text>
      </Card>
      <GroupRequirementsCard />
      <MatchingGoalsCard selected={goalColumn} onSelect={onGoalColumnChange} />
    </Stack>
  );
}
